import { ref } from 'vue';
import axios from 'axios';

const base_url = import.meta.env.VITE_API_URL;

export function useStudentInfo() {
  const studentInfo = ref(null); // the student the user picked
  const students = ref([]); // search results to choose from

  const searchStudents = async (searchText) => {
    const q = searchText.trim();
    if (q.length < 3) {
      students.value = [];
      return;
    }
    try {
      const response = await axios.get(`${base_url}/studentinfo/${q}`);
      students.value = response.data.status === 'success' ? response.data.data : [];
    } catch (error) {
      console.error('Error fetching student info:', error);
      students.value = [];
    }
  };

  return {
    studentInfo,
    students,
    searchStudents,
  };
}
